import React, { useEffect, useState } from "react";
import { Container, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import InputMask from "react-input-mask";
import TopHeader from "../Common/TopHeader";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ActivateDeactivate, Checkeligibility, RevertFormattedPhoneNumber, textValidator, restrictIntialSpace, DisplayToaster, DisplayErrorMessages, formatLocData, checkDisbale } from "../../core/services/sharedService";
import { GetApiMethod, PostApiMethod } from "../../core/services/apiService";
import { useAppSelector } from "../../core/redux/hooks";
import constant from "../../core/constant";
import { CompactPicker } from 'react-color';
import AppModal from "../AppModal/AppModal";
import "./Location.css";
import MultiPMSconnection from "./MultiPMSconnection";

const EditLocation = () => {

    const { register, handleSubmit, getValues, formState: { errors }, setError, setValue, resetField } = useForm<any>();

    const [disable, setDisable] = useState(false);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [fileSize, setFileSize] = useState(false);
    const [fileValidation, setFileValidation] = useState(false);
    const [agentCheck, setAgentCheck] = useState(false);
    const location = useLocation();
    Checkeligibility(constant.LOCATION_EDIT, location, constant.LOCATION_LIST);
    const editLocationStateInitialValues = {
        id: "", name: "", address: "", state: "", city: "", zipCode: "", call_forward: "", contact: "", primaryagent: "", secagent: "", primaryagent_id: "",
        secagent_id: "", presentation: "", footer_image: "", background_color: "", customer_contact: "", is_active: null, callTreeData: [], timeZone: "",
        voiceMailEmail: "", sendRecording: Boolean, mailToAgents: Boolean, hummingBirdOrSSM: "", kiosk_home_screen_logo: ""
    }
    const { id, name, address, state, city, zipCode, call_forward, contact, primaryagent, secagent, primaryagent_id, secagent_id, presentation, footer_image, background_color, customer_contact, is_active, activeHrs, callTreeData, callTreeAudio, timeZone, voiceMailEmail, sendRecording, mailToAgents, kiosk_home_screen_logo } = location.state || editLocationStateInitialValues;
    const [number, setNumber] = useState(contact ? contact.toString().substring(1) : '');
    const [callForwardNumber, setCallForwardNumber] = useState(call_forward ? call_forward.toString().substring(1) : "");
    const [customerContact, setCustomerContact] = useState(customer_contact ? customer_contact.toString().substring(1) : "");
    const navigate = useNavigate();
    const [resultData, setResultData] = useState("");
    const [backGroundColor, setBackGroundColor] = useState<string>(background_color ? background_color : '#ffffff');
    const [footerImage, setFooterImage] = React.useState<any>(footer_image ? footer_image : undefined);
    const [kioskHomeScreenLogo, setKioskHomeScreenLogo] = React.useState<any>(kiosk_home_screen_logo ? kiosk_home_screen_logo : undefined);
    const [showPopUp, setShowPopUp] = useState(false);
    const locationUrl = "tenant/location-crud";
    const [enableCallTree, setEnableCallTree] = React.useState(location.state?.enableCallTree);
    const [enableVoiceMail, setEnableVoiceMail] = React.useState(location.state?.enableVoiceMail);
    const [treeData, setTreeData] = React.useState<any>(location.state?.callTreeData);
    const handleColorPickerChange = (color: any) => setBackGroundColor((color && color.hex) ? color.hex : '#ffffff');
    const [callTreeInformationToPlay, setCallTreeInformationToPlay] = React.useState(location.state.callTreeInformationToPlay);
    const [customerFacingNumber, setCustomerFacingNumber] = useState<string>();
    const [agentForwardingNumber, setAgentForwardingNumber] = useState<string>();
    const [timeOffDetails, setTimeOffDetails] = React.useState(activeHrs);
    let LoginUserDetails = useAppSelector((state) => state.auth.users);
    const [LoginUserType, setLoginUserType] = useState<boolean>(LoginUserDetails && 'role' in LoginUserDetails && LoginUserDetails.role === "super_admin" ? false : true);
    const [agentMappedLocationDetails, setAgentMappedLocationDetails] = useState([{
        name: "",
        id: null
    }]);

    const [callTreeAudioFile, setCallTreeAudioFile] = React.useState("");
    const [audioFileDelete, setAudioFileDelete] = useState(false);
    const [videoFileDelete, setVideoFileDelete] = useState(false);
    const [callTreeAudioFileInput, setCallTreeAudioFileInput] = React.useState(location.state?.callTreeAudioFile);
    const [presentationVideo, setPresentationVideo] = React.useState(location.state?.presentation);
    const [sendRecordingVal, setSendRecordingVal] = React.useState(location.state?.sendRecording);
    const [mailToAgentsVal, setMailToAgentsVal] = React.useState(location.state?.mailToAgents);
    const [voicemailAudioFileDelete, setVoicemailAudioFileDelete] = useState(false);
    const [voicemailAudioFile, setVoicemailAudioFile] = React.useState("");
    const [voicemailAudioFileInput, setVoicemailAudioFileInput] = React.useState(location.state?.voicemailAudio);
    const [additionalEmailAddress, setAdditionalEmailAddress] = React.useState("");
    const [enableDisableAttachRecording, setEnableDisableAttachRecording] = React.useState((location.state.enableVoiceMail && ((location.state.voiceMailEmail !== "" && location.state.voiceMailEmail !== undefined && location.state.voiceMailEmail !== "null") || location.state.mailToAgents)) === true ? false : true);
    const [handleEnableDisableEmailToAgentToggle, setHandleEnableDisableEmailToAgentToggle] = useState<boolean>((location.state.enableVoiceMail && (primaryagent !== undefined || secagent !== undefined)) === true ? false : true);
    const [hummingBirdOrSSM, setHummingBirdOrSSM] = React.useState<string>(location.state?.hummingBirdOrSSM ?? "false");
    const [kioskHomeScreenLogoDelete, setKioskHomeScreenLogoDelete] = useState(false);

    useEffect(() => {
        (async () => {
            const result = await GetApiMethod('tenant/agent-crud');
            const ActiveLocations = result.data.data.filter((items: any) => (items.isActive))
            setResultData(ActiveLocations);
            GetApiMethod(locationUrl).then((res) => {
                let newArray = formatLocData(res.data.data);
                setAgentMappedLocationDetails((prevState) => [...newArray]);
                setCallTreeAudioFile(location.state?.callTreeAudioFile);
            });
        })();
    }, []);

    const allowedExtensionTypes: any = ["webm", "mp4", "ogv", "mov", "ogg"];
    const allowedImageExtensionTypes: string[] = ["jpg", "png", "jpeg"];

    const handleVideotype = (e: any) => {
        let fileExtension = (e.target.files[0]?.name.split(".").at(-1));
        if (fileExtension !== undefined && !allowedExtensionTypes.includes(fileExtension)) {
            DisplayToaster("bg-danger", "File type is not supported. Files type must be " + allowedExtensionTypes.join(", "));
            setFileValidation(true);
            // setDisable(true);
            return false;
        } else {
            setPresentationVideo(URL.createObjectURL(e.target.files[0]));
            setFileValidation(false);
            // setDisable(false);
        }
    }


    const handleImageType = React.useCallback((event: any, fromField = "") => {
        try {
            const fileType = event.target?.files[0]?.name?.split(".").at(-1);
            if (!fileType || (fileType && !allowedImageExtensionTypes.includes(fileType))) {
                setFileValidation(true);
                DisplayToaster("bg-danger", "File type is not supported. Files type must be " + allowedExtensionTypes.join(", "));
            } else {
                if (fromField === "kiosk_home_screen_logo") {
                    setKioskHomeScreenLogo(URL.createObjectURL(event.target.files[0]));
                    setKioskHomeScreenLogoDelete(false);
                } else {
                    setFooterImage(URL.createObjectURL(event.target.files[0]));
                }
                setFileValidation(false);
            }
        } catch (error) {
            console.log(error, 'error while handling image extension');
        }

    }, []);

    const handleChange = (e: any) => {
        if (getValues('primary_agent') && (getValues('primary_agent') === getValues('secondary_agent'))) {
            DisplayToaster("bg-danger", "Primary and Secondary agents should be different");
            setAgentCheck(true);
            // setDisable(true);
            return false;
        } else {
            setAgentCheck(false);
            // setDisable(false);
        }
    }

    const mobileCheck = (num: any) => {
        if ((getValues('contact') && getValues('contact') !== "(") && (getValues('contact') === getValues('call_forward'))) {
            DisplayToaster("bg-danger", "Twilio Number and Agent Unavailable Phone Number should be different.");
            setAgentCheck(true);
        } else {
            setAgentCheck(false);
        }
        const phoneNumber = RevertFormattedPhoneNumber(num.target.value);
        setNumber(phoneNumber);
    }

    const call_forward_check = (num: any) => {
        if (LoginUserDetails && 'role' in LoginUserDetails && LoginUserDetails.role === "vendor_admin") {
            if (RevertFormattedPhoneNumber(getValues('call_forward')) === number) {
                DisplayToaster("bg-danger", "Twilio Number and Agent Unavailable Phone Number should be different.");
                setAgentCheck(true);
            } else {
                setAgentCheck(false);
            }
        } else {
            if ((getValues('call_forward') && getValues('call_forward') !== "(") && (getValues('contact') === getValues('call_forward'))) {
                DisplayToaster("bg-danger", "Twilio Number and Agent Unavailable Phone Number should be different.");
                setAgentCheck(true);
            } else {
                setAgentCheck(false);
            }
        }
        const phoneNumber = RevertFormattedPhoneNumber(num.target.value);
        if (num.target.name === "call_forward") {
            setCallForwardNumber(phoneNumber);
        }
        else {
            setCustomerContact(phoneNumber);
        }
    }

    const pageDisable = () => {
        setDisable(true);
        setLoading(true);
        document.body.classList.add('screen-disable');
    }

    const pageEnable = () => {
        setDisable(false);
        setLoading(false);
        document.body.classList.remove('screen-disable');
    }

    const handleRegistration = (data: any) => {
        setDisable(true);
        setLoading(true);
        const form_Data = new FormData();
        const payloadValue = [{ value: data.name, minLength: 4, maxLength: 40, key: 'name' }, { value: data.address, minLength: 4, maxLength: 100, key: 'address' }, { value: data.city, minLength: 2, maxLength: 100, key: 'city' }];
        const validation = textValidator(payloadValue);
        if (validation && validation.validation === true && validation.error) {
            validation.error.forEach(errorCase => {
                setError(errorCase.key, { type: errorCase.type });
            });
            setDisable(false);
            setLoading(false);
            return false;
        }
        if (data.enableVoiceMail && !mailToAgentsVal && !data.voiceMailEmail) {
            DisplayToaster("bg-danger", "Any one of the option is required : 1.Additional Voicemail Email Addresses 2.Send Voicemail Email Notifications to Agent");
            setDisable(false);
            setLoading(false);
            return false;
        }

        form_Data.append('name', data.name?.trim());
        form_Data.append('address', data.address?.trim());
        // If customer Admin update, contact should not change. 
        LoginUserType ? form_Data.append('contact', location?.state?.contact) : data.contact && form_Data.append('contact', RevertFormattedPhoneNumber("1" + data.contact));
        // data.contact && form_Data.append('contact', RevertFormattedPhoneNumber("1" + data.contact));
        (!enableVoiceMail && data.call_forward) && form_Data.append('call_forward', RevertFormattedPhoneNumber("1" + data.call_forward));
        data.customer_contact && form_Data.append('customer_contact', RevertFormattedPhoneNumber("1" + data.customer_contact));
        form_Data.append('city', data.city?.trim());
        form_Data.append('zipCode', data.zipCode);
        form_Data.append('state', data.state);
        form_Data.append('timeZone', data.timeZone);
        form_Data.append('activeHrs', JSON.stringify(timeOffDetails));
        form_Data.append('primary_agent', data.primary_agent);
        form_Data.append('secondary_agent', data.secondary_agent);
        form_Data.append("presentation", videoFileDelete ? "" : data.presentation[0] ? data.presentation[0] : presentationVideo);
        form_Data.append("footer_image", data.kiosk_advertisement[0]);
        form_Data.append("background_color", backGroundColor);
        form_Data.append("enableCallTree", JSON.stringify(enableCallTree));
        form_Data.append("enableVoiceMail", JSON.stringify(enableVoiceMail));
        form_Data.append("voiceMailEmail", data.voiceMailEmail);
        form_Data.append("mailToAgents", mailToAgentsVal);
        form_Data.append("sendRecording", sendRecordingVal);
        form_Data.append("voicemailAudio", voicemailAudioFileInput);
        form_Data.append("pms_name", data.pms_name?.trim());
        form_Data.append("application_id", data.application_id?.trim() ?? "");
        form_Data.append("company_id", data.company_id?.trim() ?? "");
        form_Data.append("storageapi_key", data.storageapi_key?.trim() ?? "");
        form_Data.append("hummingBirdOrSSM", hummingBirdOrSSM?.toString());
        form_Data.append("ssm_user_id", data.ssm_user_id?.trim() ?? "");
        form_Data.append("ssm_password", data.ssm_password?.trim() ?? "");
        if (enableCallTree) {
            form_Data.append("callTreeData", JSON.stringify(treeData));
            form_Data.append("callTreeInformationToPlay", data?.callTreeInformationToPlay);
            form_Data.append("callTreeAudio", callTreeAudioFileInput);
        } else {
            form_Data.append("callTreeData", JSON.stringify([]));
            form_Data.append("callTreeInformationToPlay", "");
            form_Data.append("callTreeAudio", "");
        }
        form_Data.append("kiosk_home_screen_logo", kioskHomeScreenLogoDelete ? "" : data.kiosk_home_screen_logo[0] ? data.kiosk_home_screen_logo[0] : kioskHomeScreenLogo);

        if (data && data.presentation && data.presentation[0] && data.presentation[0]?.size > 500000000) {
            DisplayToaster("bg-danger", "Please upload file size below 500mb");
            setFileSize(true);
            setDisable(false);
            setLoading(false);
        } else {
            pageDisable();
            if (!fileValidation && !agentCheck) {
                if (
                    (!timeOffDetails.days.monday.holiday && (!timeOffDetails.days.monday.time || timeOffDetails.days.monday.time === "on")) ||
                    (!timeOffDetails.days.tuesday.holiday && (!timeOffDetails.days.tuesday.time || timeOffDetails.days.tuesday.time === "on")) ||
                    (!timeOffDetails.days.wednesday.holiday && (!timeOffDetails.days.wednesday.time || timeOffDetails.days.wednesday.time === "on")) ||
                    (!timeOffDetails.days.thursday.holiday && (!timeOffDetails.days.thursday.time || timeOffDetails.days.thursday.time === "on")) ||
                    (!timeOffDetails.days.friday.holiday && (!timeOffDetails.days.friday.time || timeOffDetails.days.friday.time === "on")) ||
                    (!timeOffDetails.days.saturday.holiday && (!timeOffDetails.days.saturday.time || timeOffDetails.days.saturday.time === "on")) ||
                    (!timeOffDetails.days.sunday.holiday && (!timeOffDetails.days.sunday.time || timeOffDetails.days.sunday.time === "on"))
                ) {
                    setDisable(false);
                    setLoading(false);
                    pageEnable();
                    DisplayToaster("bg-danger", "please provide work hours for all the Days");
                } else {
                    PostApiMethod('tenant/location-crud/' + id, form_Data, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }).then((res: any) => {
                        if (res.data.status === "Success") {
                            pageEnable();
                            navigate(constant.LOCATION_LIST);
                            DisplayToaster("bg-success", "Location " + data.name + " updated successfully");
                        }
                    }).catch((err: any) => {
                        pageEnable();
                        DisplayToaster("bg-danger", DisplayErrorMessages(err) ? DisplayErrorMessages(err) : "Something went wrong!");
                    });
                }

            } else {
                pageEnable();
                DisplayToaster("bg-danger", "Please check placeholder and presentation fields");
            }
        }
    };

    const handleHolidayList = (e: any) => {
        if (e.target.checked) {
            setTimeOffDetails((prevState: any) => ({
                days: { ...prevState.days, [e.target.name]: { ...prevState.days.monday, holiday: true, time: "" } }
            }))
        } else {
            let convertedTime: string;
            if (e.target.value !== "on") {
                convertedTime = e.target.value.replace(/am/g, "AM").replace(/pm/g, "PM").replace(/\s+/g, '');
            }
            setTimeOffDetails((prevState: any) => ({
                days: { ...prevState.days, [e.target.name]: { ...prevState.days.monday, holiday: false, time: e.target.value !== "on" ? convertedTime : activeHrs.days[e.target.name].time } }
            }))
        }
    }

    const addRow = React.useCallback(() => {
        setValue(`keyNumber${treeData?.length}`, null);
        setValue(`targetType${treeData?.length}`, null);
        setValue(`targetValue${treeData?.length}`, null);
        setValue(`targetDescription${treeData?.length}`, null);
        setTreeData([...treeData, {
            keyNumber: "",
            targetType: "",
            targetValue: "",
            targetDescription: ""
        }]);
    }, [treeData])

    const handleTreeDataChanges = (event: any, index: number, key: string) => {
        let val = event.target.value;
        if (key !== "targetType") {
            let isExist = treeData.some((item: any) => (item[key] === event.target.value))
            val = isExist ? (key === "keyNumber" ? null : "") : event.target.value;
        }

        treeData[index][key] = val;
        setValue(`${key}${index}`, val);
        setTreeData([...treeData])
    }
    const removeField = (e: any, i: number) => {
        let newArray = treeData.filter((item: any, index: number) => (index !== i));
        setValue(`targetType${i}`, null);
        setValue(`keyNumber${i}`, null);
        setValue(`targetValue${i}`, null);
        setValue(`targetDescription${i}`, null);
        setTreeData(newArray);
        for (let j = 0; j < newArray?.length; j++) {
            setValue(`keyNumber${j}`, newArray[j].keyNumber);
            setValue(`targetValue${j}`, newArray[j].targetValue);
            setValue(`targetType${j}`, newArray[j].targetType);
            setValue(`targetDescription${j}`, newArray[j].targetDescription);
        }
    }

    const validAudioFileType: any = constant.AUDIO_FILE_EXTENSIONS;
    const handleAudiotype = (e: any) => {
        let fileExtension = (e.target.files[0]?.name.split(".").at(-1));
        if (fileExtension !== undefined && !validAudioFileType?.includes(fileExtension)) {
            setFileValidation(true);
            DisplayToaster("bg-danger", "File type is not supported. Files type must be " + validAudioFileType?.join(", "));
            return false;
        } else {
            if (e.target.files[0].size > 20000000) {
                setFileValidation(true);
                DisplayToaster("bg-danger", "Uploaded file size should  be below 20MB.")
                return false;
            } else {
                setCallTreeAudioFile(URL.createObjectURL(e.target.files[0]));
                setCallTreeAudioFileInput(e.target.files[0]);
                setAudioFileDelete(false);
                setVideoFileDelete(false);
                setFileValidation(false);
            }
        }
    }

    const deleteAudioFile = React.useCallback(() => {
        setValue('callTreeAudio', null);
        setCallTreeAudioFile("");
        setCallTreeAudioFileInput("");
        setAudioFileDelete(true);
    }, []);

    const deletePresentationVideoFile = React.useCallback(() => {
        setValue('presentation', "");
        setPresentationVideo("");
        setVideoFileDelete(true);
    }, []);

    const deleteKioskHomeScreenLogoFile = React.useCallback(() => {
        setValue('kiosk_home_screen_logo', null);
        setKioskHomeScreenLogo("");
        setKioskHomeScreenLogoDelete(true);
    }, []);

    const handleVoicemailAudio = (e: any) => {
        let fileExtension = (e.target.files[0]?.name.split(".").at(-1));
        if (new RegExp("\\s+").test(e.target.files[0]?.name)) {
            setFileValidation(true);
            DisplayToaster("bg-danger", "File name should not contain spaces");
            return false;
        }
        if (fileExtension !== undefined && !validAudioFileType?.includes(fileExtension)) {
            setFileValidation(true);
            DisplayToaster("bg-danger", "File type is not supported. Files type must be " + validAudioFileType?.join(", "));
            return false;
        } else {
            if (e.target.files[0].size > 20000000) {
                setFileValidation(true);
                DisplayToaster("bg-danger", "Uploaded file size should  be below 20MB.")
                return false;
            } else {
                setFileValidation(false);
                setVoicemailAudioFileDelete(false);
                setVoicemailAudioFile(URL.createObjectURL(e.target.files[0]));
                setVoicemailAudioFileInput(e.target.files[0]);
            }
        }
    }

    const deleteVoicemailAudioFile = React.useCallback(() => {
        setValue('voicemailAudio', null);
        setVoicemailAudioFileDelete(true);
        setVoicemailAudioFileInput("");
        setFileValidation(false);
    }, []);

    const handleMailAgents = (e: any) => {
        if (e.target.checked) {
            if (location.state.enableVoiceMail || getValues('enableVoiceMail')) {
                setEnableDisableAttachRecording(false);
            }
        } else {
            if (getValues('voiceMailEmail')) {
                setEnableDisableAttachRecording(false);
            } else {
                setEnableDisableAttachRecording(true);
            }
        }
    }

    const handleVoiceMail = (e: any) => {
        setEnableVoiceMail(e.target.checked);
        setAdditionalEmailAddress("");
        if (e.target.checked) {
            if (getValues('mailToAgents') || getValues('voiceMailEmail') || (location.state.mailToAgents) || (location.state.voiceMailEmail)) {
                setEnableDisableAttachRecording(false);
            }
        } else {
            setEnableDisableAttachRecording(true);
        }
    }


    const handleAdditionalEmail = (e: any) => {
        setAdditionalEmailAddress(e.target.value);
        if (e.target.value || getValues('mailToAgents')) {
            setEnableDisableAttachRecording(false);
        } else {
            setEnableDisableAttachRecording(true);
        }
    }

    const enableDisableEmailToAgentsToggle = () => {
        if (getValues('enableVoiceMail') && (getValues('primary_agent') !== "" || getValues('secondary_agent') !== "")) {
            setHandleEnableDisableEmailToAgentToggle(false);
        } else {
            setHandleEnableDisableEmailToAgentToggle(true);
            setMailToAgentsVal(false);
        }
    }

    const toggleValues = (e: any) => {
        setHummingBirdOrSSM(e.target.checked.toString());
    }

    return (
        <Container fluid className="conatiner mt-3">
            <TopHeader disable={disable} heading={"Edit Location - " + name} to={constant.LOCATION_LIST} action="List" className="bi bi-list-ul" id="location-list" />
            {
                showPopUp &&
                (
                    <AppModal
                        title={`Confirm To ${location.state.is_active ? "Deactivate" : "Activate"}!`}
                        bodyText={
                            `Are you sure to ${location.state.is_active ? "deactivate" : "activate"} this Location ?`
                        }
                        primaryButtonLabel={"Yes"}
                        secondaryButtonLabel={"No"}
                        primaryButtonEventEmitter={() => { ActivateDeactivate("Location", location.state.name, "tenant/location-crud", location.state.id, location.state.is_active, () => { navigate("/location") }); setShowPopUp(false) }
                        }
                        secondaryButtonEventEmitter={() => setShowPopUp(false)}
                    />
                )
            }
            <Form onSubmit={handleSubmit(handleRegistration)}>
                <div className='row mb-2'>
                    <div className='col-md-4'>
                        <label>Name <span className='text-danger'>*</span></label>
                    </div>
                    <div className='col-md-4'>
                        <input type="text" defaultValue={name} placeholder="My Storage Location" onKeyDown={(e) => restrictIntialSpace(e)} className="form-control" {...register('name', { required: true, minLength: 4, maxLength: 40 })} />
                        {errors.name?.type === "required" && <small className='text-danger' >Name is required</small>}
                        {errors.name?.type === "minLength" && <small className='text-danger' >Minimum 4 characters is required</small>}
                        {errors.name?.type === "maxLength" && <small className='text-danger' >Maximum 40 characters only allowed</small>}
                    </div>
                </div>
                <div className='row mb-2'>
                    <div className='col-md-4'>
                        <label>Address <span className='text-danger'>*</span></label>
                    </div>
                    <div className='col-md-4'>
                        <textarea defaultValue={address} placeholder="123 Main St" onKeyDown={(e) => restrictIntialSpace(e)} className="form-control"  {...register('address', { required: true, minLength: 4, maxLength: 100 })} />
                        {errors.address?.type === "required" && <small className='text-danger' >Address is required</small>}
                        {errors.address?.type === "minLength" && <small className='text-danger' >Minimum 4 characters is required</small>}
                        {errors.address?.type === "maxLength" && <small className='text-danger' >Maximum 100 characters only allowed</small>}
                    </div>
                </div>

                <div className='row mb-2'>
                    <div className='col-md-4'>
                        <label>City <span className='text-danger'>*</span></label>
                    </div>
                    <div className='col-md-4'>
                        <input type="text" placeholder="Longview" onKeyDown={(e) => restrictIntialSpace(e)} defaultValue={city} className="form-control" {...register('city', { required: true, minLength: 2, maxLength: 40 })} />
                        {errors.city?.type === "required" && <small className='text-danger' >City is required</small>}
                        {errors.city?.type === "minLength" && <small className='text-danger' >Minimum 2 characters is required</small>}
                        {errors.city?.type === "maxLength" && <small className='text-danger' >Maximum 40 characters only allowed</small>}
                    </div>
                </div>

                <div className='row mb-2'>
                    <div className='col-md-4'>
                        <label>Zip Code <span className='text-danger'>*</span></label>
                    </div>
                    <div className='col-md-4'>
                        <input type="text" placeholder="523264" onKeyDown={(e) => restrictIntialSpace(e)} defaultValue={zipCode} className="form-control" {...register('zipCode', {
                            required: true, pattern: {
                                value: /^\d*$/,
                                message: 'Zip code field should contain only and numbers',
                            }, minLength: 4, maxLength: 10,
                        })} />
                        {errors.zipCode?.type === "required" && <small className='text-danger' >Zip Code is required</small>}
                        {errors.zipCode && errors.zipCode.type === "pattern" && <small className='text-danger' >Zip Code should contain only numbers</small>}
                        {errors.zipCode?.type === "minLength" && <small className='text-danger' >Minimum 4 characters is required</small>}
                        {errors.zipCode?.type === "maxLength" && <small className='text-danger' >Maximum 10 characters only allowed</small>}
                    </div>
                </div>

                {/* <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>State <span className='text-danger'>*</span></label>
                        </div>
                        <div className='col-md-4'>
                            <input type="text" minLength={2} maxLength={40} defaultValue={state} className="form-control" {...register('state', { required: true, minLength: 2 })} />
                            {errors.state?.type === "required" && <small className='text-danger' >State is required</small>}
                            {errors.state?.type === "minLength" && <small className='text-danger' >Minimum 2 characters is required</small>}
                        </div>
                    </div> */}

                <div className='row mb-2'>
                    <div className='col-md-4'>
                        <label>State <span className='text-danger'>*</span></label>
                    </div>
                    <div className='col-md-4'>
                        <select className="form-select" defaultValue={state} {...register('state', { required: true })}>
                            <option value={state} hidden>
                                {state}
                            </option>
                            <option value="">Select</option>
                            {Object.values(constant.StatesArray).map((items: any, i: number) => {
                                return <option key={i} value={items.name}>{items.name}</option>
                            })}
                        </select>
                        {errors.state && <small className='text-danger' >State is required</small>}
                    </div>
                </div>

                <div className="row mb-2">
                    <div className="col-md-4">
                        <label>Time Zone<span className='text-danger'>*</span></label>
                    </div>
                    <div className="col-md-4">
                        <select className="form-control" defaultValue={timeZone} {...register('timeZone', { required: true })}>
                            <option value="">Select</option>
                            {constant.timeZones?.map((item, index) => (
                                <option value={item} key={item + index}>{item}</option>
                            ))}
                        </select>
                        {errors?.timeZone?.type === "required" && <small className='text-danger' >Time zone is required</small>}
                    </div>
                </div>

                <MultiPMSconnection
                    register={register}
                    errors={errors}
                    hummingBirdOrSSM={hummingBirdOrSSM}
                    pms_name={location.state?.pms_name}
                    application_id={location.state?.application_id}
                    company_id={location.state?.company_id}
                    storageapi_key={location.state?.storageapi_key}
                    ssm_user_id={location.state?.ssm_user_id}
                    ssm_password={location.state?.ssm_password}
                    toggleValues={toggleValues}
                    resetField={resetField}
                    page={"edit_location"}
                    setValue={setValue}
                />

                <fieldset className="border p-2 col-md-8">
                    <legend className="float-none w-auto p-0 m-0">Voicemail</legend>
                    <div className="row mt-0">
                        <div className="col-md-6">
                            Voicemail Option
                        </div>
                        <div className="col-md-6">
                            <div className="form-check ml-4 form-switch col-md-1 cus-toggle">
                                {/* <input onChange={() => { setEnableVoiceMail(!enableVoiceMail) }} defaultChecked={enableVoiceMail} className="form-check-input" type="checkbox" role="switch" /> */}
                                <input {...register('enableVoiceMail', { onChange: (e) => { handleVoiceMail(e); enableDisableEmailToAgentsToggle() } })} defaultChecked={enableVoiceMail} className="form-check-input" type="checkbox" role="switch" />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <label> Send Voicemail Email Notifications to Agent </label>
                            <strong className="agentEmail">
                                <i className="bi bi-question-circle ml-2" style={{ fontSize: '20px', position: 'relative', top: '2px' }}></i>
                            </strong>
                            <div className="tooltip-popup send-voicemail">Enabling this option will forward voicemails to both the primary and secondary agents of that location.</div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-check ml-4 form-switch col-md-1 cus-toggle agentEmail">
                                {/* <input onChange={() => { setMailToAgentsVal(!mailToAgentsVal) }} defaultChecked={mailToAgentsVal} className="form-check-input" type="checkbox" role="switch" disabled={(enableVoiceMail ? false : true )}/> */}
                                <input  {...register('mailToAgents', { onChange: (e) => { setMailToAgentsVal(!mailToAgentsVal); handleMailAgents(e) } })} checked={mailToAgentsVal} className="form-check-input" type="checkbox" role="switch" disabled={(handleEnableDisableEmailToAgentToggle === false ? false : true)} />
                            </div>
                            <div className="tooltip-popup send-voicemail-toggle">Please assign Primary or Secondary Agent to enable this option</div>
                        </div>
                    </div>

                    <div className="row mb-2">
                        <div className="col-md-6 p-0 pl-2">
                            <label> Additional Voicemail Email Addresses {(enableVoiceMail && !mailToAgentsVal) ? <span className="text-danger">*</span> : ""}</label>
                            <strong className="agentEmail">
                                <i className="bi bi-question-circle ml-2" style={{ fontSize: '20px', position: 'relative', top: '2px' }}></i>
                            </strong>
                            <div className="tooltip-popup additional-voicemail">Please add the email addresses of the recipients to whom you want to send the voicemails.</div>
                        </div>
                        <div className="col-md-6 pl-2">
                            <input
                                defaultValue={voiceMailEmail}
                                {...register('voiceMailEmail',
                                    {
                                        pattern: {
                                            value: /^[\w\.-]+(?:[\w\.-]+)*@(?:[\w-]+\.)+[a-zA-Z]{2,7}(?:,\s*[\w\.-]+(?:[\w\.-]+)*@(?:[\w-]+\.)+[a-zA-Z]{2,7})*$/,
                                            message: 'Please provide valid email address',
                                        },
                                        onChange: (e) => { handleAdditionalEmail(e) }
                                    })
                                }
                                type="text"
                                // value={additionalEmailAddress ? additionalEmailAddress : ""}
                                onKeyDown={(e) => { restrictIntialSpace(e) }}
                                className="form-control"
                                readOnly={(enableVoiceMail ? false : true)}
                            />
                            {errors[`voiceMailEmail`]?.type === "pattern" && <small className='text-danger' >{`Invalid email format`}</small>}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <label> Attach Voicemail Recording to Emails</label>
                            <strong className="agentEmail"><i className="bi bi-question-circle ml-2" style={{ fontSize: '20px', position: 'relative', top: '2px' }}></i></strong>
                            <div className="tooltip-popup attach-voicemail">Enabling this option will include Voicemail Recording as attachment in the voicemail notification email.</div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-check ml-4 form-switch col-md-1 cus-toggle">
                                <input onChange={() => { setSendRecordingVal(!sendRecordingVal) }} defaultChecked={sendRecordingVal} className="form-check-input" type="checkbox" role="switch" disabled={enableDisableAttachRecording} />
                            </div>
                        </div>
                    </div>

                    <div className='row mb-2'>
                        <div className='col-md-6 p-0'>
                            <label>Voicemail Audio</label>
                        </div>
                        <div className='col-md-5 p-0' style={{ paddingLeft: '8px !important' }}>
                            <input type="file" accept="audio/*" className="form-control" {...register('voicemailAudio', { required: false, onChange: (e) => { handleVoicemailAudio(e) } })} />
                            <small className="text-primary">Supported formats : {validAudioFileType?.join(", ")} </small><br />
                            <small className="text-primary">{`Please make sure there are no spaces in the file name when uploading.`} </small><br />
                        </div>
                        <div className='col-md-1 p-0 mt-1'>
                            <span onClick={deleteVoicemailAudioFile} ><i className="bi bi-trash text-danger m-1" style={{ fontSize: 24 }}></i></span>
                        </div>
                        <div className='offset-md-6 col-md-5 mt-3 p-0'>
                            <audio src={voicemailAudioFileDelete && voicemailAudioFile == "" ? "" : voicemailAudioFile ? voicemailAudioFile : location.state?.voicemailAudio} controls>
                                <source src={voicemailAudioFileDelete && voicemailAudioFile == "" ? "" : voicemailAudioFile ? voicemailAudioFile : location.state?.voicemailAudio} />
                            </audio>
                        </div>
                    </div>
                </fieldset>

                <div className="row mb-2 mt-4">
                    <div className="col-md-4">
                        Call Tree Creation
                    </div>
                    <div className="row col-md-8">
                        <div className="form-check ml-4 form-switch col-md-1 cus-toggle">
                            <input onChange={() => { setEnableCallTree(!enableCallTree) }} defaultChecked={enableCallTree} className="form-check-input" type="checkbox" role="switch" />
                        </div>
                        {enableCallTree &&
                            <div className="col-md-4">
                                <button type="button" onClick={addRow} className="btn btn-sm btn-primary">Add Row</button>
                            </div>
                        }
                    </div>

                </div>
                {enableCallTree && treeData?.length > 0 &&
                    <>
                        <div className='row mb-2'>
                            <div className='col-md-4'>
                                <label>Call Tree Text <span className='text-danger'>*</span></label>
                            </div>
                            <div className='col-md-4'>
                                <input type="text" defaultValue={callTreeInformationToPlay == "undefined" || callTreeInformationToPlay == "" ? "" : callTreeInformationToPlay} onKeyDown={(e) => restrictIntialSpace(e)} placeholder="Please provide Information to play" className="form-control" {...register('callTreeInformationToPlay', { required: callTreeAudioFile == "" ? true : false, minLength: 4 })} />
                                {(errors.callTreeInformationToPlay?.type === "required" && callTreeAudioFile?.length <= 0) && <small className='text-danger' >Call Tree Information is required</small>}
                                {errors.callTreeInformationToPlay?.type === "minLength" && <small className='text-danger' >Minimum 4 characters is required</small>}
                            </div>
                        </div>

                        <div className='row mb-2'>
                            <div className='col-md-4'>
                                <label>Call Tree Audio <span className='text-danger'></span></label>
                            </div>
                            <div className='col-md-4'>
                                <input type="file" id="fileInput" accept="audio/*" className="form-control mb-2"
                                    {...register('callTreeAudio', { required: (location.state?.callTreeAudioFile == "" && callTreeAudioFile == "" && getValues('callTreeInformationToPlay') == "" ? true : false), onChange: (e) => { handleAudiotype(e) } })} />
                                {errors.callTreeAudio && <small className='text-danger' >Call Tree Audio is required<br /></small>}
                                <small className="text-primary">Supported formats : {validAudioFileType?.join(", ")} </small><br />
                                <small className="text-primary">{`Please make sure there are no spaces in the file name when uploading.`} </small><br />
                                <audio src={audioFileDelete && callTreeAudioFile == "" ? "" : callTreeAudioFile ? callTreeAudioFile : location.state?.callTreeAudioFile} controls>
                                    <source src={audioFileDelete && callTreeAudioFile == "" ? "" : callTreeAudioFile ? callTreeAudioFile : location.state?.callTreeAudioFile} />
                                </audio>
                            </div>
                            {/* <div className='col-md-1 p-0 mt-1'>
                                <div data-toggle="tooltip" title={`Please make sure there are no spaces in the file name when uploading. supported file types are ${validAudioFileType.join(',')}`}><i className="bi bi-info-circle"></i></div>
                            </div> */}

                            <div className='col-md-1 p-0 mt-1'>
                                <span onClick={deleteAudioFile} ><i className="bi bi-trash text-danger m-1" style={{ fontSize: 24 }}></i></span>
                                {/* <button type="button" onClick={deleteAudioFile} className="btn btn-sm btn-primary">Delete</button> */}
                            </div>
                        </div>
                        <div className='row mb-2'>
                            <div className="pl-4 col-3 col-md-4">
                                <label className="pl-5"><b>Key number</b> </label>
                            </div>

                            <div className="col col-md-4">
                                <div className="row">
                                    <div className="col-4 col-md-4 form-check">
                                        <b>Action</b>
                                    </div>
                                    <div className="col-4 col-md-4 form-check">
                                        <b>Description</b>
                                    </div>

                                    <div className="col-4 col-md-4">
                                        <b>target</b>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>

                }
                {
                    enableCallTree && treeData.map((item: any, i: number) => (

                        <div className='row mb-2' key={i}>
                            <div className="pl-4 pb-2  col-md-4">
                                <div className="col-md-4">
                                    <input type="number" {...register(`keyNumber${i}`, {
                                        required: true, min: 0, max: 9, pattern: {
                                            value: /^[0-9]+$/,
                                            message: 'Name field should contain only alphabets',
                                        }, onChange: (e) => { handleTreeDataChanges(e, i, 'keyNumber') }
                                    })} value={item.keyNumber} className="form-control" />
                                </div>
                                {errors[`keyNumber${i}`]?.type === "required" && <small className='text-danger' >{`Key Number ${i + 1} required`}</small>}
                                {errors[`keyNumber${i}`]?.type === "pattern" && <small className='text-danger' >{`please enter Key Number ${i + 1} value below 9`}</small>}
                                {errors[`keyNumber${i}`]?.type === "max" && <small className='text-danger' >{`please enter Key Number ${i + 1} value below 9`}</small>}
                                {errors[`keyNumber${i}`]?.type === "min" && <small className='text-danger' >{`please enter Key Number ${i + 1} value below 9`}</small>}
                            </div>

                            <div className="col col-md-5">
                                <div className="row">
                                    <div className="col-3 col-md-3 form-check">
                                        <select defaultValue={item.targetType} {...register(`targetType${i}`, { required: true, onChange: (e) => { handleTreeDataChanges(e, i, 'targetType') } })} className="form-control">
                                            <option value="">Select</option>
                                            <option value="phoneNum" >Phone Number</option>
                                            <option value="location">Location</option>
                                        </select>
                                        {errors[`targetType${i}`]?.type === "required" && <small className='text-danger' >{`Action ${i + 1} required`}</small>}
                                    </div>

                                    <div className="col-3 col-md-3 form-check">
                                        <input type="text" className="form-control" defaultValue={item.targetDescription} {...register(`targetDescription${i}`, {
                                            required: (getValues(`targetType${i}`) === "phoneNum" ? true : false), onChange: (e) => { handleTreeDataChanges(e, i, 'targetDescription') }
                                        })} />
                                        {errors[`targetDescription${i}`]?.type === "required" && <small className='text-danger' >{`Description ${i + 1} required`}</small>}
                                    </div>

                                    <div className="col-3 col-md-3">
                                        {
                                            item.targetType === "location" ?
                                                <>
                                                    <select defaultValue={item.targetValue.split(",")[1]} {...register(`targetValue${i}`, { required: true, onChange: (e) => { handleTreeDataChanges(e, i, 'targetValue') } })} className="form-control">
                                                        <option value={item.targetValue.split(",")[1]} hidden>
                                                            {item.targetValue.split(",")[1]}
                                                        </option>
                                                        <option>Select</option>
                                                        {agentMappedLocationDetails?.map((item, index) => (
                                                            <option value={item?.id + "," + item.name} key={index} disabled={checkDisbale(item?.id, treeData)} >{item.name}</option>
                                                        ))}
                                                    </select>
                                                </>

                                                : <InputMask placeholder="(123)-456-7890"
                                                    mask="(999)-999-99999" maskChar={null} type="text" {...register(`targetValue${i}`, { required: true, onChange: (e) => { handleTreeDataChanges(e, i, 'targetValue') } })} value={item?.targetValue} className="form-control" />

                                        }
                                        {errors[`targetValue${i}`]?.type === "required" && <small className='text-danger' >{`target ${i + 1} required`}</small>}

                                    </div>
                                    <div className="col-2 col-md-2">
                                        <span onClick={(e) => { removeField(e, i) }} ><i className="bi bi-trash text-danger m-1" style={{ fontSize: 24 }}></i></span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    ))
                }


                <div className='row mt-4'>
                    <div className='col-12 col-md-4'>
                        <label><b>Active Hours</b></label>
                    </div>
                </div>

                <div className="col col-md-8 col-sm-4">
                    <div className="row">
                        <div className="col-3 col-md-6">
                            <label><b>Day</b></label>
                        </div>
                        <div className="col-3 col-md-3">
                            <label><b>Holiday</b></label>
                        </div>
                        <div className="col col-md-3">
                            <label><b>Time</b> </label>
                        </div>
                    </div>
                </div>
                {/* {timeOffDetails.days.monday.holiday + "-" + timeOffDetails.days.monday.time}<br /> */}
                <div className='row mb-2'>
                    <div className="pl-4 col-3 col-md-4">
                        <label className="">Monday </label>
                    </div>
                    <div className="col col-md-4">
                        <div className="row">
                            <div className="col-3 col-md-3 form-check">
                                <input name="monday" className="form-check-input ml-1" defaultChecked={activeHrs.days.monday.holiday} onClick={(e) => { handleHolidayList(e) }} type="checkbox" />
                            </div>
                            {
                                !timeOffDetails.days.monday.holiday && (
                                    <div className="col-9 col-md-9">
                                        <input className="form-control" placeholder="09:30AM-12:30PM,01:30PM-06:30PM" defaultValue={activeHrs.days.monday.time} onChange={(e) => { handleHolidayList(e) }} name="monday" type="textbox" />
                                    </div>
                                )
                            }
                        </div>
                        {(!timeOffDetails.days.monday.holiday && (!timeOffDetails.days.monday.time || timeOffDetails.days.monday.time === "on")) && <small className="text-danger">Please mark monday as holiday or mention the work hours</small>}
                    </div>
                </div>
                <div className='row mb-2'>
                    <div className="pl-4 col-3 col-md-4">
                        <label className="">Tuesday </label>
                    </div>
                    <div className="col col-md-4">
                        <div className="row">
                            <div className="col-3 col-md-3 form-check">
                                <input name="tuesday" className="form-check-input ml-1" defaultChecked={activeHrs.days.tuesday.holiday} onClick={(e) => { handleHolidayList(e) }} type="checkbox" />
                            </div>
                            {
                                !timeOffDetails.days.tuesday.holiday && (
                                    <div className="col-9 col-md-9">
                                        <input className="form-control" placeholder="09:30AM-12:30PM,01:30PM-06:30PM" defaultValue={activeHrs.days.tuesday.time} onChange={(e) => { handleHolidayList(e) }} name="tuesday" type="textbox" />
                                    </div>
                                )
                            }
                        </div>
                        {(!timeOffDetails.days.tuesday.holiday && (!timeOffDetails.days.tuesday.time || timeOffDetails.days.tuesday.time === "on")) && <small className="text-danger">Please mark tuesday as holiday or mention the work hours</small>}
                    </div>
                </div>
                <div className='row mb-2'>
                    <div className="pl-4 col-3 col-md-4">
                        <label className="">Wednesday </label>
                    </div>

                    <div className="col col-md-4">
                        <div className="row">
                            <div className="col-3 col-md-3 form-check">
                                <input name="wednesday" className="form-check-input ml-1" defaultChecked={activeHrs.days.wednesday.holiday} onClick={(e) => { handleHolidayList(e) }} type="checkbox" />
                            </div>
                            {
                                !timeOffDetails.days.wednesday.holiday &&
                                <div className="col-9 col-md-9">
                                    <input className="form-control" placeholder="09:30AM-12:30PM,01:30PM-06:30PM" defaultValue={activeHrs.days.wednesday.time} onChange={(e) => { handleHolidayList(e) }} name="wednesday" type="textbox" />
                                </div>
                            }
                        </div>
                        {(!timeOffDetails.days.wednesday.holiday && (!timeOffDetails.days.wednesday.time || timeOffDetails.days.wednesday.time === "on")) && <small className="text-danger">Please mark wednesday as holiday or mention the work hours</small>}
                    </div>
                </div>
                <div className='row mb-2'>
                    <div className="pl-4 col-3 col-md-4">
                        <label className="">Thursday </label>
                    </div>

                    <div className="col col-md-4">
                        <div className="row">
                            <div className="col-3 col-md-3 form-check">
                                <input name="thursday" className="form-check-input ml-1" defaultChecked={activeHrs.days.thursday.holiday} onClick={(e) => { handleHolidayList(e) }} type="checkbox" />
                            </div>
                            {
                                !timeOffDetails.days.thursday.holiday &&
                                <div className="col-9 col-md-9">
                                    <input className="form-control" placeholder="09:30AM-12:30PM,01:30PM-06:30PM" defaultValue={activeHrs.days.thursday.time} onChange={(e) => { handleHolidayList(e) }} name="thursday" type="textbox" />
                                </div>
                            }
                        </div>
                        {(!timeOffDetails.days.thursday.holiday && (!timeOffDetails.days.thursday.time || timeOffDetails.days.thursday.time === "on")) && <small className="text-danger">Please mark thursday as holiday or mention the work hours</small>}
                    </div>
                </div>
                <div className='row mb-2'>
                    <div className="pl-4 col-3 col-md-4">
                        <label className="">Friday </label>
                    </div>

                    <div className="col col-md-4">
                        <div className="row">
                            <div className="col-3 col-md-3 form-check">
                                <input name="friday" className="form-check-input ml-1" defaultChecked={activeHrs.days.friday.holiday} onClick={(e) => { handleHolidayList(e) }} type="checkbox" />
                            </div>
                            {
                                !timeOffDetails.days.friday.holiday &&
                                <div className="col-9 col-md-9">
                                    <input className="form-control" placeholder="09:30AM-12:30PM,01:30PM-06:30PM" defaultValue={activeHrs.days.friday.time} onChange={(e) => { handleHolidayList(e) }} name="friday" type="textbox" />
                                </div>
                            }
                        </div>
                        {(!timeOffDetails.days.friday.holiday && (!timeOffDetails.days.friday.time || timeOffDetails.days.friday.time === "on")) && <small className="text-danger">Please mark friday as holiday or mention the work hours</small>}
                    </div>
                </div>

                <div className='row mb-2'>
                    <div className="pl-4 col-3 col-md-4">
                        <label className="">Saturday </label>
                    </div>

                    <div className="col col-md-4">
                        <div className="row">
                            <div className="col-3 col-md-3 form-check">
                                <input name="saturday" className="form-check-input ml-1" defaultChecked={activeHrs.days.saturday.holiday} onClick={(e) => { handleHolidayList(e) }} type="checkbox" />
                            </div>
                            {
                                !timeOffDetails.days.saturday.holiday &&
                                <div className="col-9 col-md-9">
                                    <input className="form-control" placeholder="09:30AM-12:30PM,01:30PM-06:30PM" defaultValue={activeHrs.days.saturday.time} onChange={(e) => { handleHolidayList(e) }} name="saturday" type="textbox" />
                                </div>
                            }
                        </div>
                        {(!timeOffDetails.days.saturday.holiday && (!timeOffDetails.days.saturday.time || timeOffDetails.days.saturday.time === "on")) && <small className="text-danger">Please mark saturday as holiday or mention the work hours</small>}
                    </div>
                </div>

                <div className='row mb-2'>
                    <div className="pl-4 col-3 col-md-4">
                        <label className="">Sunday </label>
                    </div>

                    <div className="col col-md-4">
                        <div className="row">
                            <div className="col-3 col-md-3 form-check">
                                <input name="sunday" className="form-check-input ml-1" defaultChecked={activeHrs.days.sunday.holiday} onClick={(e) => { handleHolidayList(e) }} type="checkbox" />
                            </div>
                            {
                                !timeOffDetails.days.sunday.holiday &&
                                <div className="col-9 col-md-9">
                                    <input className="form-control" placeholder="09:30AM-12:30PM,01:30PM-06:30PM" defaultValue={activeHrs.days.sunday.time} onChange={(e) => { handleHolidayList(e) }} name="sunday" type="textbox" />
                                </div>
                            }
                        </div>
                        {(!timeOffDetails.days.sunday.holiday && (!timeOffDetails.days.sunday.time || timeOffDetails.days.sunday.time === "on")) && <small className="text-danger">Please mark sunday as holiday or mention the work hours</small>}
                    </div>
                </div>

                {
                    (LoginUserDetails && 'role' in LoginUserDetails && LoginUserDetails.role === "super_admin") &&
                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>Twilio Number </label>
                        </div>
                        <div className='col-md-4'>
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <div className="input-group-text" id="btnGroupAddon"><b>+1</b></div>
                                </div>
                                <InputMask
                                    value={number}
                                    className="form-control"
                                    mask="(999)-999-99999"
                                    maskChar={null}
                                    {...register('contact', {
                                        required: (enableCallTree ? true : false), minLength: 14, maxLength: 15, onChange: (e) => { mobileCheck(e) }
                                    })}
                                />
                            </div>
                            {errors.contact?.type === "required" && <small className='text-danger' >Twilio Number is required</small>}
                            {errors.contact?.type === "minLength" && <small className='text-danger' >Minimum 10 numbers is required</small>}
                            {errors.contact?.type === "maxLength" && <small className='text-danger' >Maximum 11 numbers only allowed</small>}
                        </div>
                    </div>
                }

                {
                    !enableVoiceMail &&
                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>Agent Unavailable Forwarding Number</label>
                        </div>
                        <div className='col-md-4'>
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <div className="input-group-text" id="btnGroupAddon"><b>+1</b></div>
                                </div>
                                <InputMask
                                    value={callForwardNumber ? callForwardNumber : ""}
                                    className="form-control"
                                    mask="(999)-999-99999"
                                    maskChar={null}
                                    {...register('call_forward', {
                                        minLength: 14, maxLength: 15,
                                        onChange: (e) => { call_forward_check(e); setAgentForwardingNumber(RevertFormattedPhoneNumber(e.target.value)) },
                                    })}
                                />
                            </div>
                            {agentForwardingNumber && errors.call_forward?.type === "minLength" && <small className='text-danger' >Minimum 10 numbers is required</small>}
                            {agentForwardingNumber && errors.call_forward?.type === "maxLength" && <small className='text-danger' >Maximum 11 numbers only allowed</small>}
                        </div>
                    </div>
                }


                <div className='row mb-2'>
                    <div className='col-md-4'>
                        <label>Customer Facing Phone Number</label>
                    </div>

                    <div className='col-md-4'>
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <div className="input-group-text" id="btnGroupAddon"><b>+1</b></div>
                            </div>
                            <InputMask
                                value={customerContact ? customerContact : ""}
                                className="form-control"
                                mask="(999)-999-99999"
                                maskChar={null}
                                {...register('customer_contact', { minLength: 14, maxLength: 15, onChange: (e) => { call_forward_check(e); setCustomerFacingNumber(RevertFormattedPhoneNumber(e.target.value)) } })}
                            />
                        </div>
                        {customerFacingNumber && errors.customer_contact?.type === "minLength" && <small className='text-danger' >Minimum 10 numbers is required</small>}
                        {customerFacingNumber && errors.customer_contact?.type === "maxLength" && <small className='text-danger' >Maximum 11 numbers only allowed</small>}
                    </div>
                </div>

                <div className='row mb-2'>
                    <div className='col-md-4'>
                        <label>Status </label>
                    </div>
                    <div className='col-md-4'>
                        <input type="text" value={is_active ? "Active" : "Inactive"} disabled className="form-control" />
                    </div>
                </div>

                <div className='row mb-2'>
                    <div className='col-md-4'>
                        <label>Primary Agent </label>
                    </div>
                    <div className='col-md-4'>
                        <select className="form-select" defaultValue={primaryagent} {...register('primary_agent', { onChange: (e) => { handleChange(e); enableDisableEmailToAgentsToggle() } })}>
                            <option value={primaryagent_id} hidden>
                                {primaryagent}
                            </option>
                            <option value="">Select</option>
                            {Object.values(resultData).map((items: any, i: number) => {
                                return <option key={items._id} value={items._id}>{items.name} - {items.email}</option>
                            })}
                        </select>
                        {errors.primary_agent && <small className='text-danger' >Primary Agent is required</small>}
                    </div>
                </div>

                <div className='row mb-2'>
                    <div className='col-md-4'>
                        <label>Secondary Agent </label>
                    </div>
                    <div className='col-md-4'>
                        <select className="form-select" defaultValue={secagent} {...register('secondary_agent', { required: false, onChange: (e) => { handleChange(e); enableDisableEmailToAgentsToggle() } })}>
                            <option value={secagent_id} hidden>
                                {secagent}
                            </option>
                            <option value="">Select</option>
                            {Object.values(resultData).map((items: any, i: number) => {
                                return <option key={items._id} value={items._id}>{items.name} - {items.email}</option>
                            })}
                        </select>
                        {/* {errors.secondary_agent && <small className='text-danger' >Secondary Agent is required</small>} */}
                    </div>
                </div>

                <div className='row mb-2'>
                    <div className='col-md-4'>
                        <label>Presentation Video </label>
                    </div>
                    <div className='col-md-4'>
                        <input type="file" id="fileInput" accept="video/*" className="form-control mb-2"
                            {...register('presentation', { onChange: (e) => { handleVideotype(e) } })} />
                        {errors.presentation && <small className='text-danger' >Presentation Video is required<br /></small>}
                        <small className="text-primary">Supported formats : {allowedExtensionTypes.join(", ")} </small><br />
                        <small className='text-primary' >
                            {presentationVideo ? <video width="250" controls >
                                <source src={presentationVideo} type="video/mp4" />
                            </video> : <></>}
                        </small>
                    </div>

                    <div className='col-md-1 p-0 mt-1'>
                        <span onClick={deletePresentationVideoFile} ><i className="bi bi-trash text-danger m-1" style={{ fontSize: 24 }}></i></span>
                    </div>
                </div>
                <div className='row mb-2'>
                    <div className='col-md-4'>
                        <label>Kiosk Footer</label>
                    </div>
                    <div className='col-md-4'>
                        <input type="file" id="fileInput" accept='image/*' className="form-control" {...register('kiosk_advertisement', { onChange: (e) => { handleImageType(e) } })} />
                        <small className="text-primary">Supported formats : {allowedImageExtensionTypes.join(", ")} </small><br />
                        {
                            footerImage &&
                            <img
                                alt=""
                                src={footerImage}
                                width="70%"
                                height="auto"
                                className="d-inline-block mt-3 mb-2"
                            />
                        }
                    </div>
                </div>
                <div className='row mb-2'>
                    <div className='col-md-4'>
                        <label>Kiosk Background Color</label>
                    </div>
                    <div className='col-md-4'>
                        <CompactPicker color={backGroundColor} onChangeComplete={handleColorPickerChange} />
                    </div>
                </div>
                <div className='row mb-2'>
                    <div className='col-md-4'>
                        <label>Kiosk Home Screen Logo </label>
                    </div>
                    <div className='col-md-4'>
                        <input type="file" id="fileInput" accept='image/*' className="form-control" {...register('kiosk_home_screen_logo', { onChange: (e) => { handleImageType(e, 'kiosk_home_screen_logo') } })} />
                        <small className="text-primary">Supported formats : {allowedImageExtensionTypes.join(", ")} </small><br />
                        {kioskHomeScreenLogo &&
                            <img
                                alt=""
                                src={kioskHomeScreenLogo}
                                width="70%"
                                height="auto"
                                className="d-inline-block mt-3 mb-2"
                            />
                        }
                    </div>
                    <div className='col-md-1 p-0 mt-1'>
                        <span onClick={deleteKioskHomeScreenLogoFile} ><i className="bi bi-trash text-danger m-1" style={{ fontSize: 24 }}></i></span>
                    </div>
                </div>
                <div className='text-center'>
                    <button type="submit" disabled={disable || agentCheck || fileValidation} className='btn btn-primary m-2 app-button-color'>{isLoading && <span className="spinner-border text-white mr-1" style={{ width: '18px', height: "18px" }} role="status"></span>}{" "} Update</button>
                    {/* {location.state && <button type="button" className={is_active ? "btn btn-danger" : "btn btn-success"} onClick={(e) => { ActDeactLocation(e, id, name, is_active) }} >{is_active ? "Deactivate" : "Activate"}</button>} */}
                    {location.state && <button type="button" className={is_active ? "btn btn-danger" : "btn btn-success"} onClick={(e) => { setShowPopUp(true) }} >{is_active ? "Deactivate" : "Activate"}</button>}
                    {disable ? <Link to={constant.LOCATION_LIST} className="disabledCursor" onClick={(event) => event.preventDefault()}><button type="reset" disabled={disable} className='btn btn-secondary m-2'>Cancel</button></Link> : <Link to={constant.LOCATION_LIST}><button type="reset" className='btn btn-secondary m-2'>Cancel</button></Link>}
                </div>
            </Form>
        </Container>
    )
}

export default EditLocation;